export const TelegramUsersModel = {
    id: null,
    user: null,
    user_email: "",
    user_name: "",
    user_token: "",
    telegram_id: null,
    telegram_username: "",
    telegram_first_name: "",
    telegram_last_name: "",
    first_name: "",
    last_name: "",
    description: "",
    display_name: "",
    is_verified: false,
    is_active: true,
    notifications_enabled: true,
    invitation_token: "",
    invitation_link: "",
    orgs_names: "",
    panels_names: "",
    organizations: [],
    panels: [],
};

export const TelegramUsersDateModel = {
    created_at: "",
    updated_at: "",
};
